import type { BoxPolicy } from '@deepcloud/api-deep-box'

export function useBoxPolicy() {
  function canAdminAccess({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminAccess ?? false
  }

  function canAdminAddresses({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminAddresses ?? false
  }

  function canAdminGenerics({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminGenerics ?? false
  }

  function canAdminRelations({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminRelations ?? false
  }

  function canAdminShares({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminShares ?? false
  }

  function canAdminVariant({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminVariant ?? false
  }

  function canAdminWebhooks({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canAdminWebhooks ?? false
  }

  function canPurge({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canPurge ?? false
  }

  function canRename({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canRename ?? false
  }

  /*
   * API do not provide any policy to check if user can show/hide hidden nodes
   * we use the box policy "canRename" for this purpose, which has the same result
   * */
  function canListHiddenNodes({ boxPolicy }: { boxPolicy: BoxPolicy }) {
    return boxPolicy?.canRename ?? false
  }

  return {
    canAdminAccess,
    canAdminAddresses,
    canAdminGenerics,
    canAdminRelations,
    canAdminShares,
    canAdminVariant,
    canAdminWebhooks,
    canPurge,
    canRename,
    canListHiddenNodes,
  }
}
